module.exports = {
    onCreate() {
        this.state = {
            isSticky: false,
            isCategoryLayerHeader: false,
            totalStickyHeight: 0
        };
    },
    onMount() {
        this.setElements();
        this.handleStickyHeader();
        this.handleScrollToTop();
    },
    setElements() {
        this.rootEl = this.getEl('str-mini-header-wrap');
        this.sentinelEl = document.querySelector('.str-header__sticky-sentinel'); // In str-header component
        this.controlbarEl = document.querySelector('.str-controlbar-wrap');
        this.tabPanelEl = document.querySelector('.str-tabs');
    },
    handleStickyHeader() {
        document.addEventListener('sticky-headers-event', e => {
            this.state.isSticky = e.detail.isSticky;
            this.toggleMiniHeader();
            this.setTotalStickyHeight();
        });
        document.addEventListener('category-layer-header-event', e => {
            this.state.isCategoryLayerHeader = e.detail.enable;
            this.toggleMiniHeader();
            this.setTotalStickyHeight();
        });
        this.observeStickyIntersection();
    },
    // Scroll to top of content
    handleScrollToTop() {
        document.addEventListener('str-tab-change-event', () => { this.scrollToTop(); });
        document.addEventListener('scroll-to-sticky-top', () => { this.scrollToTop(); });
    },
    scrollToTop() {
        if (this.state.isSticky) {
            const tabpanelTop = this.tabPanelEl.getBoundingClientRect().y;
            const scrollTo = tabpanelTop + window.scrollY - this.state.totalStickyHeight;
            window.scrollTo(0, scrollTo);
        }
    },
    // Need total sticky height to get the scroll-to-top position.
    // When the tabs are changed, we scroll to the top of the content.
    setTotalStickyHeight() {
        if (this.rootEl.offsetHeight) {
            this.state.totalStickyHeight = this.rootEl.offsetHeight + this.getControlbarHeight();
        }
    },
    getControlbarHeight() {
        if (this.controlbarEl) {
            return this.controlbarEl.offsetHeight;
        }
        return 70;
    },
    toggleMiniHeader() {
        if (this.state.isSticky || this.state.isCategoryLayerHeader) {
            this.rootEl.style.display = 'flex';
        } else {
            this.rootEl.style.display = 'none';
        }
    },
    observeStickyIntersection: function() {
        if (window.IntersectionObserver) {
            // When the user scrolls up and the str-header__sticky-sentinel
            // element goes beyond the viewport, it no longer intersects it.
            // We dispatch the 'sticky-headers-event' to update isSticky state.
            const callback = (entries) => {
                // The body.offsetHeight needs to be greater than 0.
                // This is an issue on the Store Management preview layer, where the page is
                // loaded in an iframe. When the mweb iframe is on the hidden tab panel, the body
                // has zero height. When that's the case, we shouldn't set sticky=true.
                if (document.body.offsetHeight > 0) {
                    const { isIntersecting, boundingClientRect } = entries[0];
                    // Don't set isSticky=true when the sentinel goes below the bottom of the viewport.
                    const sentinalBelowBottom = window.innerHeight < boundingClientRect.y;
                    let isSticky = false;
                    if (!isIntersecting && !sentinalBelowBottom) {
                        isSticky = true;
                    }
                    const event = new CustomEvent('sticky-headers-event', { detail: { isSticky: isSticky } });
                    document.dispatchEvent(event);
                }
            };
            new IntersectionObserver(callback).observe(this.sentinelEl);
        }
    }
};
